import { ShopsAvailable } from '@availability/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { encodeUid } from '@shared/helpers';
import { StateUtils } from '@spartacus/core';
import { AvailabilityState, StateWithAvailability } from '../availability-state';
import { getAvailabilityFeatureState } from './feature.selector';

type ShopsAvailableState = AvailabilityState['shopsAvailable'];

export const getShopsAvailableState: MemoizedSelector<StateWithAvailability, ShopsAvailableState> = createSelector(
  getAvailabilityFeatureState,
  (state: AvailabilityState) => state.shopsAvailable,
);

export const getShopsAvailable = (
  productCode: string,
  unitCode: string,
): MemoizedSelector<StateWithAvailability, StateUtils.LoaderState<ShopsAvailable>> =>
  createSelector(getShopsAvailableState, (state: ShopsAvailableState) =>
    StateUtils.entityLoaderStateSelector<ShopsAvailable>(state, encodeUid(productCode, unitCode)),
  );

export const getShopsAvailableValue = (
  productCode: string,
  unitCode: string,
): MemoizedSelector<StateWithAvailability, ShopsAvailable> =>
  createSelector(getShopsAvailableState, (state: ShopsAvailableState) =>
    StateUtils.entityValueSelector<ShopsAvailable>(state, encodeUid(productCode, unitCode)),
  );

export const getShopsAvailableLoading = (
  productCode: string,
  unitCode: string,
): MemoizedSelector<StateWithAvailability, boolean> =>
  createSelector(getShopsAvailableState, (state: ShopsAvailableState) =>
    StateUtils.entityLoadingSelector<ShopsAvailable>(state, encodeUid(productCode, unitCode)),
  );

export const getShopsAvailableError = (
  productCode: string,
  unitCode: string,
): MemoizedSelector<StateWithAvailability, boolean> =>
  createSelector(getShopsAvailableState, (state: ShopsAvailableState) =>
    StateUtils.entityErrorSelector<ShopsAvailable>(state, encodeUid(productCode, unitCode)),
  );

export const getShopsAvailableSuccess = (
  productCode: string,
  unitCode: string,
): MemoizedSelector<StateWithAvailability, boolean> =>
  createSelector(getShopsAvailableState, (state: ShopsAvailableState) =>
    StateUtils.entitySuccessSelector<ShopsAvailable>(state, encodeUid(productCode, unitCode)),
  );
